import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Area from './model';

export const getOrganizationAreas = organizationId => {
    return RESTClient.getAuthenticated('v2/institutiongroupings', {
        organizationId,
    });
};

export const createArea = (organizationId, title) => {
    return RESTClient.postAuthenticatedObservable('v2/institutiongroupings', {
        organizationId,
        title,
    }).map(data => Area.fromAPI(data.institutionGrouping));
};

export const addInstitutionToArea = (areaId, institutionId) => {
    return RESTClient.postAuthenticatedObservable(`v2/institutiongroupings/${areaId}/institutions`, {
        institutionId,
    }).map(updatedAreaData => Area.fromAPI(updatedAreaData.institutionGrouping));
};

export const removeInstitutionFromArea = (areaId, institutionId) => {
    return RESTClient.deleteAuthenticatedObservable(
        `v2/institutiongroupings/${areaId}/institutions/${institutionId}`,
    ).map(updatedAreaData => Area.fromAPI(updatedAreaData.institutionGrouping));
};
